import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const initializeLanguages = () => {
  const apiURL = process.env.REACT_APP_SERVER_URL;

  const lngDetector = new LanguageDetector(null, {
    // order and from where user language should be detected
    order: ["localStorage"],
  });
  i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(HttpApi)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(lngDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options

    .init({
      ns: ["v0.5"], // must be more dynamic to add modules ns
      defaultNS: "v0.5",
      backend: {
        // loadPath: '/locales/{{lng}}/{{ns}}.json',
        // loadPath: `${apiURL}/api/files/?file=/translations/{{ns}}/{{lng}}.json`,
        loadPath: `${apiURL}/api/files/?file=/translations/{{ns}}/{{lng}}.json`,
      },
      debug: false,
      load: "currentOnly",
      fallbackLng: "en-GB",
      partialBundledLanguages: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });
};

let currentLangConfig = "";
export const changeLanguageNamespace = (prefix: string) => {
  if (currentLangConfig !== prefix) {
    currentLangConfig = prefix;
    i18n.setDefaultNamespace(prefix);
  }
};

export default initializeLanguages;
